// Pfad: src/config/config.js
// Zweck/Funktion: Frontend-Konfig – API-Basis & Keys nur per ENV (kein fest kodierter C3PO-Key).

const browserHost =
  typeof window !== "undefined" && window.location && window.location.hostname
    ? window.location.hostname
    : "";

const fallbackURL =
  browserHost === "localhost" || browserHost === "127.0.0.1"
    ? "http://localhost:5000"
    : "https://api.experts4europe.com";
const envURL = process.env.REACT_APP_API_BASE_URL;
const API_BASE_URL = (envURL && envURL.startsWith("http")) ? envURL : fallbackURL;

if (!envURL || envURL === "undefined") {
  console.warn("[config.js] Warnung: REACT_APP_API_BASE_URL ist nicht gesetzt. Fallback wird verwendet:", fallbackURL);
}

// C3PO-Key ausschließlich aus ENV (kein Hardcode-Fallback mehr)
const C3PO_KEY = process.env.REACT_APP_C3PO_KEY || "";

const config = { API_BASE_URL, C3PO_KEY };
export { API_BASE_URL, C3PO_KEY };
export default config;
